var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"header-margin"}),_c('UpgradePackagePanel'),_c('ExplanationPopup'),(_vm.isUserSuperadmin)?_c('SearchFloatButton'):_vm._e(),(!_vm.isLoading)?_c('router-view',{staticClass:"view"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }